import { render } from "./serverDetail.vue?vue&type=template&id=18d20a1b&scoped=true"
import script from "./serverDetail.vue?vue&type=script&lang=js"
export * from "./serverDetail.vue?vue&type=script&lang=js"

import "./serverDetail.vue?vue&type=style&index=0&id=18d20a1b&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d20a1b"]])

export default __exports__